import React, { FC } from 'react';
import styled from 'styled-components';

import BaseCard, { IBaseCard } from '@ui/atoms/BaseCard';
import BasicText from '@ui/atoms/BasicText';
import FlexColumn, { IFlexColumn } from '@ui/atoms/FlexColumn';
import FlexRow, { IFlexRow } from '@ui/atoms/FlexRow';

import aligned from '@ui/styled/Aligned';
import padded from '@ui/styled/Padded';
import wrapped from '@ui/styled/Wrapped';

import Arrow from '@assets/vectors/icon-arrow.inline.svg';

import theme from '@theme/FolxTheme';

interface IContactCardProps {
	id: string;
	name: string;
	phone: string;
	relationship: string;
	email?: string;
	handleClick?: (id: string) => void;
}

const PaddedCard = padded<IBaseCard>(BaseCard);
const AlignedRow = aligned<IFlexRow>(FlexRow);
const WrappedColumn = wrapped<IFlexColumn>(FlexColumn);

const ContactButton = styled.button`
	padding: ${theme.spacing.smmd};
	text-align: start;
	min-height: ${theme.spacing.xxxxl};
`;

const ContactCard: FC<IContactCardProps> = ({
	email,
	id,
	handleClick = () => {
		return;
	},
	name,
	phone,
	relationship,
}) => {
	return (
		<PaddedCard radius="md" shadow padding="none" bgColor="white" borderless>
			<ContactButton onClick={() => handleClick(id)}>
				<AlignedRow gap="xs" alignItems="center" justifyContent="space-between">
					<WrappedColumn flexWrap="wrap" gap="xs">
						<BasicText>{name}</BasicText>
						<BasicText variant="fineprintBold">{relationship}</BasicText>
						<BasicText variant="fineprint">{phone}</BasicText>
						{email && <BasicText variant="fineprint">{email}</BasicText>}
					</WrappedColumn>
					<Arrow height={theme.spacing.md} width={theme.spacing.md} style={{ flexShrink: 0 }} />
				</AlignedRow>
			</ContactButton>
		</PaddedCard>
	);
};

export default styled(ContactCard)``;
